import { render } from "./sidebar.vue?vue&type=template&id=ca5e38ac"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca5e38ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca5e38ac', __exports__)) {
    console.log('reload')
    api.reload('ca5e38ac', __exports__)
  }
  
  module.hot.accept("./sidebar.vue?vue&type=template&id=ca5e38ac", () => {
    console.log('re-render')
    api.rerender('ca5e38ac', render)
  })

}


export default __exports__